import { of, Observable, throwError as _throw } from 'rxjs';
import {
	Component,
	ComponentFactoryResolver,
	Inject,
	OnInit,
	ViewChild,
	ViewContainerRef,
	ViewEncapsulation,
} from '@angular/core';
import { mergeMap } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

import * as _ from 'lodash';
import moment from 'moment';

// Environment
import { environment } from '../../environments/environment';

import * as Papi from '@app/papi';
import { AlertService } from './_services/alert.service';
import { StorageService } from './_services/storage.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { Helpers } from '../helpers';

import { AuthResetForgotPassword } from 'papi-client-ng2';

import * as Cognito from './cognito';

import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
	selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
	templateUrl: './templates/login.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class AuthComponent implements OnInit {
	model: any = {};
	loading = false;
	returnUrl: string;

	@ViewChild('alertSignin', {
    read: ViewContainerRef,
    static: true
}) alertSignin: ViewContainerRef;

	@ViewChild('alertSignup', {
    read: ViewContainerRef,
    static: true
}) alertSignup: ViewContainerRef;

	@ViewChild('alertForgotPass', {
    read: ViewContainerRef,
    static: true
}) alertForgotPass: ViewContainerRef;

	@ViewChild('forgotSuccess', { static: true }) private forgotSuccess: SwalComponent;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private http: HttpClient,
		private papi: Papi.Service,
		private alertService: AlertService,
		private cfr: ComponentFactoryResolver,
		private cognito: Cognito.CognitoService,
		private storage: StorageService
	) { }

	ngOnInit() {
		let code: string = null;
		let response: Cognito.AuthResponse = this.cognito.instance || {};

		this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/index';
		const remember = localStorage.getItem('rememberMe') === 'true';
		this.model.remember = remember;
		this.model.email = remember ? localStorage.getItem('savedEmail') || '' : '';
		this.model.usePassword = false;
		this.model.password = null;
		LoginCustom.displayPassword(false);

		try {
			Helpers.setLoading(false);
			LoginCustom.init();
			// code = this.cognito.getRedirectResult();
			// if (_.isEmpty(this.cognito.instance)) {		// no cognito data is present which implies papi auth
			// 	this.router.navigate([this.returnUrl]);
			// 	Helpers.setLoading(false);
			// 	LoginCustom.init();
			// } else if (!_.isEmpty(code)) {
			// 	this.signinCognito(code);
			// 	this.pollCognito();
			// } else if (!_.isEmpty(response.token)) {
			// 	this.cognito.refresh().subscribe((data: Auth) => {
			// 		this.router.navigate([this.returnUrl]);
			// 		this.pollCognito();
			// 		Helpers.setLoading(false);
			// 		LoginCustom.init();
			// 	}, (error: Error) => {
			// 		this.papi.logout();
			// 		throw error;
			// 	});
			// } else {
			// 	throw new Error('Error validating Cognito user');
			// }
		} catch (error) {
			this.cognito.logout();
			this.showAlert('alertSignin');
			this.alertService.error(new HttpErrorResponse({ error: error, status: 500, statusText: 'Error validating Cognito user', url: this.router.url }));
			this.loading = false;
		}
	}

	signinCognito(code: string) {
		this.loading = true;
		// return this.cognito.signin(code).subscribe((data: any) => {
		// 	this.router.navigate(['/']);
		// }, (error: any) => {
		// 	this.papi.logout();
		// 	this.cognito.logout();
		// 	this.showAlert('alertSignin');
		// 	this.alertService.error(error);
		// 	this.loading = false;
		// });
		this.loading = false;
	}

	pollCognito() {
		const pollInterval: number = (environment.cognito.pollInterval || 1) * 1000 * 60;		// minutes
		const cognitoAuthResponse: Cognito.AuthResponse = this.cognito.instance;

		let timer: any = null;

		if (_.isEmpty(cognitoAuthResponse) || _.isEmpty(cognitoAuthResponse.token)) {
			return timer = setTimeout(() => {
				this.pollCognito();
			}, pollInterval);
		}

		return timer = setTimeout(() => {
			const token: Cognito.Token = cognitoAuthResponse.token;
			const created: moment.Moment = token.created;
			const now: moment.Moment = moment().utc();
			const initial: number = parseInt(<string>token.expires_in, 10);
			const expiry: number = initial / 60;		// @TODO - change this to hours
			const tolerence: number = environment.cognito.refreshTolerence;		// tolerence in minutes
			const diff: number = <number>now.diff(created, 'minutes')

			// if ((<number>moment().utc().diff(created, 'hours')) > expiry - tolerence) {
			// if ((<number>now.diff(created, 'hours')) > expiry - tolerence) {
			if (diff > expiry - tolerence) {
				// this.refreshCognito().subscribe((data: any) => {
				this.cognito.refresh().subscribe((data: any) => {
					this.pollCognito();
				}, (error: any) => {

				})
			} else {
				this.pollCognito();
			}
		}, pollInterval)
	}

	signinPapi() {
		if (!this.model.password) {
			this.showAlert('alertSignin');
			this.alertService.errorMessage('Password is required');
			return;
		} else {
		
		this.loading = true;
		this.papi.login(this.model.email, this.model.password).pipe(mergeMap((data) => {
			return this.papi.authorize('arcadmin').pipe(mergeMap((data) => {
				if (data) {
					if (this.model.remember) {
						localStorage.setItem('rememberMe', 'true');
						localStorage.setItem('savedEmail', this.model.email);
						sessionStorage.setItem('rememberMe', 'true');
					} else {
						localStorage.setItem('rememberMe', 'false');
						localStorage.removeItem('savedEmail');
						sessionStorage.setItem('rememberMe', 'false');
					}
					return of(true);
				} else {
					return _throw(new HttpErrorResponse({ error: new Error('Forbidden'), status: 403, statusText: 'Forbidden', url: this.router.url }));
				}
			}));
		})).subscribe((data) => {
			this.router.navigate([this.returnUrl]);
			this.cognito.logout();
		}, (error) => {
			this.papi.logout();
			this.cognito.logout();
			this.model.password = null;
			this.showAlert('alertSignin');
			this.alertService.error(error);
			this.loading = false;
		});
	}
	}

	signin() {	
		if(this.model.password === null) {
			this.cognito.query(this.model.email || '').subscribe((result: Cognito.AuthResponse) => {
				if (!_.isEmpty(result)) {
					LoginCustom.displayPassword(true);
					this.cognito.redirectForCode(result);
				} else if (_.isEmpty(this.model.password) && !this.model.usePassword) {
					this.model.usePassword = true;
					LoginCustom.displayPassword(true);
				} else {
					this.signinPapi();
				}

				/*
				if (_.isEmpty(result)) {
					this.signinPapi();
				} else {
					this.cognito.redirectForCode(result);
				}
				*/
			});
		} else {
			this.signinPapi();
		}
	}

	signup() {
		this.loading = true;
		// this.userService.create(this.model).subscribe(
		// 	data => {
		// 		this.showAlert('alertSignin');
		// 		this.alertService.success(
		// 			'Thank you. To complete your registration please check your email.',
		// 			true);
		// 		this.loading = false;
		// 		LoginCustom.displaySignInForm();
		// 		this.model = {};
		// 	},
		// 	error => {
		// 		this.showAlert('alertSignup');
		// 		this.alertService.error(error);
		// 		this.loading = false;
		// 	});
	}

	forgotPass() {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!this.model.email || !emailRegex.test(this.model.email)) {
			this.showAlert('alertForgotPass');
			this.alertService.error(new HttpErrorResponse({ error: 'Please enter a valid email address.', status: 400, statusText: 'Please enter a valid email address.', url: this.router.url }));
			this.loading = false;
			return;
		}
		const model: AuthResetForgotPassword = {
			email: this.model.email
		};

		this.loading = true;
		this.papi.fauxInit();
		this.papi.db.authResetForgotPassword(model, 'body', true).subscribe((data) => {
			this.forgotSuccess.fire().then(() => {
				this.loading = false;
				this.router.navigate(['forgot', 'password', model.email]);
			});
		}, (error) => {
			this.showAlert('alertForgotPass');
			this.alertService.error(new HttpErrorResponse({ error: error.message, status: 400, statusText: error.message, url: this.router.url }));
			this.loading = false;
		});

		/*
		this.alertService.success('Password recovery instructions have been sent to your email address.');		// why is this not showing any ui change?
		alert('Password recovery instructions have been sent to your email address.');		// we do NOT want to rely on standard alert()
		LoginCustom.displaySignInForm();
		this.loading = false;
		*/

		// this.userService.forgotPassword(this.model.email).subscribe(
		// 	data => {
		// 		this.showAlert('alertSignin');
		// 		this.alertService.success(
		// 			'Cool! Password recovery instruction has been sent to your email.',
		// 			true);
		// 		this.loading = false;
		// 		LoginCustom.displaySignInForm();
		// 		this.model = {};
		// 	},
		// 	error => {
		// 		this.showAlert('alertForgotPass');
		// 		this.alertService.error(error);
		// 		this.loading = false;
		// 	});
	}

	showAlert(target) {
		this[target].clear();
		let factory = this.cfr.resolveComponentFactory(AlertComponent);
		let ref = this[target].createComponent(factory);
		ref.changeDetectorRef.detectChanges();
	}
}